import { Theme } from '@mui/material/styles'
import { MapOptions } from 'google-maps-react-markers'

/**
 * Generate Options for google map
 *
 * @reference - https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions
 */
export const getMapOptions = (theme: Theme): MapOptions => {
  return {
    zoomControlOptions: {
      position: 1, // top left
    },
    cameraControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    gestureHandling: 'cooperative',
    styles: [
      {
        featureType: 'all',
        elementType: 'labels.text',
        stylers: [
          {
            color: theme.palette.grey[500],
          },
        ],
      },
      {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
          {
            color: theme.palette.grey[100],
          },
        ],
      },
      {
        featureType: 'poi',
        stylers: [
          {
            color: theme.palette.primary.light,
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text',
        stylers: [
          {
            color: theme.palette.primary.main,
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [
          {
            color: '#f5f5f5',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#c9c9c9',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'all',
        stylers: [
          {
            color: '#B6E8EE',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels',
        stylers: [
          {
            color: '#B6E8EE',
          },
        ],
      },
    ],
  }
}
